export enum AppPathEnums {
  ROOT_ROUTE = "/",
  AUTH_ROUTE = "/sign-in",
  USER_HOME = "/dashboard",
  ERROR_PAGE = "/error",
}
